import React, {forwardRef} from 'react'
import {Box, MenuItem} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const A11yMenuItem = forwardRef(
    (
        {
            propagateAs = 'button',
            type,
            // as per https://hub.accessible360.com/kb/articles/529#heading-navigation-menus-are-not-application-menus
            // we should not use role="menuitem" on the menu item and navigation should be based on tab
            // so we remove the tabIndex which prevents the tab key from working
            role,
            tabIndex,
            ...props
        },
        ref
    ) => <Box as={propagateAs} ref={ref} {...props} />
)

if (process.env.NODE_ENV !== 'production') {
    A11yMenuItem.displayName = 'A11yMenuItem'
}

A11yMenuItem.propTypes = {
    role: PropTypes.string,
    type: PropTypes.string,
    propagateAs: PropTypes.elementType,
    tabIndex: PropTypes.number
}

const StokkeMenuItem = ({as, ...props}) => {
    return <MenuItem {...props} as={A11yMenuItem} propagateAs={as} />
}

StokkeMenuItem.propTypes = {
    as: PropTypes.elementType
}

export default StokkeMenuItem
